import { trackStart } from "./utils/adobeAnalytics";

interface LandingPageProps {
  setStarted: (value: boolean) => void;
}

export function LandingPage({ setStarted }: LandingPageProps) {
  function backToTop(){
    let innerContent = document.getElementById("innerContent");
    if(innerContent){
      innerContent.scrollIntoView({behavior: "instant", inline: "start"});
    }
  }

  const handleStart = () => {
    backToTop()
    trackStart()
    setStarted(true)
  }

  return (
    <main className="cq-h-full cq-bg-cfa-bright-blue-20 cq-pt-11 cq-flex cq-justify-center">
      <section id="innerContent" className="cq-flex cq-min-h-auto cq-max-h-auto cq-scroll-my-[7rem] cq-flex-col md:cq-flex-row md:cq-justify-center cq-max-w-container">
        <div className="cq-mx-8 cq-mt-16 md:cq-my-32 cq-text-center md:cq-text-left md:cq-w-full md:cq-max-w-[400px]">
          <span className="cq-block cq-text-xs md:cq-text-sm cq-font-medium cq-uppercase cq-text-black cq-mb-1">
            Investment Career Accelerator Network
          </span>

          <h1 className="md:cq-mt-4 cq-text-4xl md:cq-text-6xl cq-leading-[1.2] cq-text-black cq-font-medium">
            Career insight.
            <br /> Tailor-made.
          </h1>

          <span className="cq-text-base md:cq-text-lg md:cq-leading-[1.4] cq-text-black">
            <p className="cq-pb-8 cq-pt-4">
              The future feels good when it’s the right fit. Answer these 10 questions about your strengths, values and interests and we’ll show you which finance career path might suit you best.
            </p>
            <p className="cq-pb-8 cq-pt-4">
              Takes 5 minutes.
            </p>
          </span>
          
          <button
            onClick={handleStart}
            className="cq-text-sm md:cq-text-base cq-inline-flex cq-items-center cq-justify-center cq-rounded-full cq-bg-white hover:cq-bg-[#F2F2F2] cq-px-6 md:cq-px-10 cq-w-[138px] cq-h-[40px] md:cq-w-[183px] md:cq-h-[48px] cq-py-4 cq-font-medium cq-text-black cq-shadow cq-hover:bg-white cq-hover:ring-indigo-500 cq-focus:outline-none cq-cursor-pointer"
          >
            Take the quiz
          </button>
        </div>

        <div className="cq-mt-16 md:cq-mx-8">
          <img
            loading="lazy"
            src={`${import.meta.env.BASE_URL}images/hero.png`}
            alt="People at work"
            className="cq-w-full cq-h-auto cq-object-contain"
          />
        </div>
      </section>
    </main>
  );
}
